import { PLAN_MANAGEMENT_V2 } from '../../../../paths'

export const PLAN_LOCATION_OVERRIDES = `/${PLAN_MANAGEMENT_V2}/overrides/locations`

export const planLocationOverridesPath = (subtab?: string) =>
  subtab
    ? `${PLAN_LOCATION_OVERRIDES}/${subtab.toLowerCase()}`
    : `${PLAN_LOCATION_OVERRIDES}/inactive`
